import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { LanguageProvider, useLang } from "@/lib/i18n";
import { NAV_ITEMS } from "@/lib/site";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { TaxiShowcase } from "@/components/site/TaxiShowcase";
import { WhyUs } from "@/components/site/WhyUs";
import { Reviews } from "@/components/site/Reviews";
import { Area } from "@/components/site/Area";
import { HowItWorks } from "@/components/site/HowItWorks";
import { About } from "@/components/site/About";
import { Booking } from "@/components/site/Booking";
import { ContactBand } from "@/components/site/ContactBand";
import { Footer } from "@/components/site/Footer";
import { MobileBar } from "@/components/site/MobileBar";

const Page = ({ children }) => <div className="pt-[68px]">{children}</div>;

const HomePage = () => (
    <>
        <Hero />
        <Marquee />
        <WhyUs />
        <Reviews />
        <ContactBand />
    </>
);

const ServicesPage = () => (
    <Page>
        <Services />
        <ContactBand />
    </Page>
);

const AreaPage = () => (
    <Page>
        <Area />
        <ContactBand />
    </Page>
);

const TaxiPage = () => (
    <Page>
        <TaxiShowcase />
        <ContactBand />
    </Page>
);

const AboutPage = () => (
    <Page>
        <About />
        <ContactBand />
    </Page>
);

const BookingPage = () => (
    <Page>
        <HowItWorks />
        <Booking />
    </Page>
);

const ContactPage = () => (
    <Page>
        <ContactBand />
    </Page>
);

const ScrollManager = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) {
            window.__lenis.scrollTo(0, { immediate: true });
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname]);
    return null;
};

const SITE_URL = "https://taxidrunen.com";

const TitleManager = () => {
    const { t } = useLang();
    const { pathname } = useLocation();
    useEffect(() => {
        const item = NAV_ITEMS.find((n) => n.path === pathname) || NAV_ITEMS[0];
        document.title = t.pageTitles[item.key];
        const canonical = `${SITE_URL}${item.path === "/" ? "/" : item.path}`;
        document.querySelector('link[rel="canonical"]')?.setAttribute("href", canonical);
        document.querySelector('meta[property="og:url"]')?.setAttribute("content", canonical);
    }, [pathname, t]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let frame;
        const raf = (time) => {
            lenis.raf(time);
            frame = requestAnimationFrame(raf);
        };
        frame = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(frame);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <LanguageProvider>
            <BrowserRouter>
                <div className="App bg-night-950 text-slate-100">
                    <Header />
                    <ScrollManager />
                    <TitleManager />
                    <main>
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/diensten" element={<ServicesPage />} />
                            <Route path="/werkgebied" element={<AreaPage />} />
                            <Route path="/onze-taxi" element={<TaxiPage />} />
                            <Route path="/over-ons" element={<AboutPage />} />
                            <Route path="/boeken" element={<BookingPage />} />
                            <Route path="/contact" element={<ContactPage />} />
                            <Route path="*" element={<HomePage />} />
                        </Routes>
                    </main>
                    <Footer />
                    <MobileBar />
                </div>
            </BrowserRouter>
        </LanguageProvider>
    );
}

export default App;
